import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { SubSink } from 'subsink';

import { SubjectsService } from 'src/app/core/services/subjects.service';

import { ModalBalanceOtrosProductosDto } from 'src/app/feature/monitoreo/data/ModalBalanceOtrosProductosDto';

@Component({
  selector: 'app-balance-otros-productos',
  templateUrl: './balance-otros-productos.component.html',
  styleUrls: ['./balance-otros-productos.component.css']
})
export class BalanceOtrosProductosComponent implements OnInit, OnDestroy {

  @ViewChild('paginadorBalance') paginadorBalance!: MatPaginator;
  @ViewChild('sortBalance') sortBalance!: MatSort;

  public modalBalanceOtrosProductosDto: ModalBalanceOtrosProductosDto;

  public subs = new SubSink();

  public displayedProducts: string[] = [
    'Recargas',
    'Facturas'
  ];

  public columns: string[];

  public dataSource: MatTableDataSource<ModalBalanceOtrosProductosDto>;

  constructor(
    public dialog: MatDialog,
    private readonly subjectServices: SubjectsService,
    private cdr: ChangeDetectorRef
  ) {

    this.modalBalanceOtrosProductosDto = new ModalBalanceOtrosProductosDto();
  }

  ngOnInit(): void {
    this.paginationDataTable();
  }

  public paginationDataTable(): void {

    this.subs.add(this.subjectServices.informacionModalBalanceOtrosProductosGet.subscribe({
      next: (data) => {
        this.modalBalanceOtrosProductosDto = data;
        this.cdr.markForCheck();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
